// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__13XAh","legacyBtn":"MutateMid_legacyBtn__2VJ43"};